(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ps-navigation"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.ps-nav').forEach(nav => {
  const menus = Array.from(nav.querySelectorAll('details'));
  menus.forEach(menu => menu.addEventListener('toggle', () => {
    if (menu.open) menus.forEach(other => { if (other !== menu) other.open = false; });
  }));
  nav.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const opened = menus.find(menu => menu.open);
      if (opened) { opened.open = false; opened.querySelector('summary').focus(); }
    }
  });
  document.addEventListener('click', event => {
    if (!nav.contains(event.target)) menus.forEach(menu => { menu.open = false; });
  });
});
  } catch(e) { console.error(e); }
})();

})();
